"use client";

import React from "react";
import { SVG } from "../../constants/svg";

export function Layout24() {
  return (
    <section id="relume" className="px-[5%] py-16 md:py-24 lg:py-28">
      <div className="container">
        <div className="grid grid-cols-1 gap-y-12 md:grid-cols-2 md:items-center md:gap-x-12 lg:gap-x-20">
          <div>
            <div className="rb-5 mb-5 md:mb-6">
              <img
                src="https://d22po4pjz3o32e.cloudfront.net/relume-icon.svg"
                className="size-12"
                alt="Relume logo"
              />
            </div>
            <h3 className="mb-5 text-4xl font-bold leading-[1.2] md:mb-6 md:text-5xl lg:text-6xl">
              Unlock Endless Storytelling Possibilities with Omnigeist's
              Innovative Platform
            </h3>
            <p className="md:text-md">
              Omnigeist empowers story creators by providing a seamless
              transition across various media formats, ensuring consistency and
              depth in every narrative. For audiences, this means immersive
              experiences that evolve and expand, keeping them engaged and
              connected to their favorite stories.
            </p>
          </div>
          <div>
            <img
              src="/assets/svg/hero-placeholder.svg"
              className="w-full object-cover"
              alt="Omnigeist hero illustration"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
